// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { RATag } = require('components/RAComponents/RATag/RATag');
// @ utilities
import { formatText } from 'core/i18n';
// @ constants
const {
    DISABLED_PROBABILITY,
    HIGH_PROBABILITY,
    LOW_PROBABILITY,
    MEDIUM_PROBABILITY,
    NONE_PROBABILITY,
} = require('constants/RAConstants/index');

class RAProbabilityTag extends React.Component {
    render() {
        const { label } = this.props;
        const key = `raProbabilityTag-raProbabilityTag_${label}`;
        const contentTag = formatText(key);
        let type;

        switch (label) {
            case HIGH_PROBABILITY:
                type = 'success';
                break;
            case MEDIUM_PROBABILITY:
                type = 'pending';
                break;
            case LOW_PROBABILITY:
            case NONE_PROBABILITY:
                type = 'informative';
                break;
            case DISABLED_PROBABILITY:
                type = 'disabled';
                break;
        }

        return <RATag content={contentTag} type={type} />;
    }
}

RAProbabilityTag.propTypes = {
    label: PropTypes.string.isRequired,
};

module.exports = RAProbabilityTag;
